module.exports = __webpack_public_path__ + "img/Video.9b82f03.svg";